<template>
  <a-modal
    :visible="isInvoiceModalVisible"
    :title="$t('INVOICE_MODAL_TITLE')"
    centered
    :footer="null"
    @cancel="closeInvoiceModal"
  >
    <div class="invoice-modal-body">
      <a-icon type="file-text" class="invoice-modal-icon" />
      <p class="invoice-modal-text">{{ $t('INVOICE_MODAL_CONTENT') }}</p>
      <div class="invoice-modal-info">
        <div class="invoice-modal-info-header">
          <span class="invoice-modal-info-label">{{ $t('INVOICE_MODAL_INFO_LABEL') }}</span>
          <a-button
            type="link"
            size="small"
            class="invoice-modal-copy-btn"
            @click="copyInfo"
          >
            <a-icon type="copy" />
            {{ $t('INVOICE_MODAL_COPY_BTN') }}
          </a-button>
        </div>
        <a-textarea
          :value="infoTemplate"
          read-only
          :auto-size="{ minRows: 6, maxRows: 10 }"
          class="invoice-modal-textarea"
        />
      </div>
      <div class="invoice-modal-actions">
        <a
          :href="configApp.contact.zalo"
          target="_blank"
          rel="noopener noreferrer"
          class="invoice-modal-zalo-btn"
        >
          <img src="/img/zalo.png" alt="Zalo" class="invoice-modal-zalo-icon" />
          {{ $t('INVOICE_MODAL_ZALO_BTN') }}
        </a>
        <a
          href="https://m.me/toolautoshopee"
          target="_blank"
          rel="noopener noreferrer"
          class="invoice-modal-fb-btn"
        >
          <i class="fab fa-facebook-messenger"></i>
          {{ $t('INVOICE_MODAL_FB_BTN') }}
        </a>
        <a-button @click="closeInvoiceModal">
          {{ $t('INVOICE_MODAL_CLOSE_BTN') }}
        </a-button>
      </div>
    </div>
  </a-modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'InvoicePopup',
  computed: {
    ...mapGetters('ui', ['isInvoiceModalVisible']),
    infoTemplate() {
      return this.$t('INVOICE_MODAL_INFO_TEMPLATE');
    },
  },
  methods: {
    ...mapActions('ui', ['closeInvoiceModal']),
    async copyInfo() {
      try {
        await navigator.clipboard.writeText(this.infoTemplate);
        this.$message.success(this.$t('INVOICE_MODAL_COPIED'));
      } catch (e) {
        const textarea = document.createElement('textarea');
        textarea.value = this.infoTemplate;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
        this.$message.success(this.$t('INVOICE_MODAL_COPIED'));
      }
    },
  },
};
</script>

<style scoped>
.invoice-modal-body {
  text-align: center;
  padding: var(--spacing-sm) 0;
}

.invoice-modal-icon {
  font-size: 48px;
  color: var(--primary-color);
  margin-bottom: var(--spacing-md);
}

.invoice-modal-text {
  font-size: var(--font-size-base);
  color: var(--text-primary);
  line-height: var(--line-height-relaxed);
  margin-bottom: var(--spacing-lg);
}

.invoice-modal-info {
  text-align: left;
  margin-bottom: var(--spacing-lg);
}

.invoice-modal-info-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: var(--spacing-xs);
  gap: var(--spacing-sm);
}

.invoice-modal-info-label {
  font-weight: var(--font-weight-medium);
  color: var(--text-primary);
  font-size: var(--font-size-sm);
}

.invoice-modal-copy-btn {
  padding: 0;
  height: auto;
  white-space: nowrap;
}

.invoice-modal-textarea {
  font-size: var(--font-size-sm);
  line-height: var(--line-height-relaxed);
  background: var(--gray-100, #f5f5f5);
  color: var(--text-primary);
  cursor: text;
}

.invoice-modal-actions {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: var(--spacing-md);
  flex-wrap: wrap;
}

.invoice-modal-zalo-btn {
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-xs);
  padding: var(--spacing-sm) var(--spacing-lg);
  border-radius: var(--border-radius-md);
  background: #0068ff;
  color: var(--text-inverse);
  font-weight: var(--font-weight-medium);
  text-decoration: none;
  transition: all var(--transition-base);
}

.invoice-modal-zalo-btn:hover {
  background: #0052cc;
  color: var(--text-inverse);
}

.invoice-modal-zalo-icon {
  width: 20px;
  height: 20px;
  object-fit: contain;
}

.invoice-modal-fb-btn {
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-xs);
  padding: var(--spacing-sm) var(--spacing-lg);
  border-radius: var(--border-radius-md);
  background: #1877f2;
  color: var(--text-inverse);
  font-weight: var(--font-weight-medium);
  text-decoration: none;
  transition: all var(--transition-base);
}

.invoice-modal-fb-btn:hover {
  background: #0d65d9;
  color: var(--text-inverse);
}
</style>
